export type StepContinueResolution =
  | { kind: 'handler'; nextStep: number }
  | { kind: 'quotation' }
  | { kind: 'blocked' };

export function resolveNextStepChatOnContinue(currentStep: number, steps: number[]): StepContinueResolution {
  if (!steps.length) {
    return { kind: 'blocked' };
  }
  const sorted = [...steps].sort((a, b) => a - b);
  const nextStep = sorted.find((n) => n > currentStep);
  if (nextStep !== undefined) {
    return { kind: 'handler', nextStep };
  }
  const lastStep = sorted[sorted.length - 1];
  if (currentStep === lastStep) {
    return { kind: 'quotation' };
  }
  return { kind: 'blocked' };
}
